function scaleImage(wi: number, hi: number, ws: number, hs: number) {
    let rs = ws / hs;
    let ri = wi / hi;

    return rs > ri ? {
        imageWidth: wi * hs / hi,
        imageHeight: hs
    } : {
            imageWidth: ws,
            imageHeight: hi * ws / wi
        };

    // rs > ri ? (wi * hs/hi, hs) : (ws, hi * ws/wi)
}

function paintBucket(context: CanvasRenderingContext2D, startX: number, startY: number, fillColor : number[]) {
    // function paintBucket(context, startX, startY) {

    startX = parseInt(startX.toFixed(0));
    startY = parseInt(startY.toFixed(0));

    let startPointImageData = context.getImageData(startX, startY, 1, 1);
    //console.log(startPointImageData);
    let startR = startPointImageData.data[0];
    let startG = startPointImageData.data[1];
    let startB = startPointImageData.data[2];
    let startA = startPointImageData.data[3];

    let [fillR, fillG, fillB, fillA] = fillColor;

    if(isNaN(fillR) || isNaN(fillG) || isNaN(fillB) || isNaN(fillA))                return;
    if(startR == fillR && startG == fillG && startB == fillB && startA == fillA)    return console.warn("Stopped FillingSameColor")//alert('no');
    if(matchStartColorByColor({ R: fillR, G: fillG, B: fillB, A: fillA }))          return console.warn("Stopped FillingSameColor")

    let canvasWidth = context.canvas.width;
    let canvasHeight = context.canvas.height;

    let imageData = context.getImageData(0, 0, canvasWidth, canvasHeight);
    // console.log('GET IMAGE DATA');

    let pixelStack = [[startX, startY]];

    while (pixelStack.length) {
        let newPos = pixelStack.pop();
        let [x, y] = newPos;

        var pixelPos = (y * canvasWidth + x) * 4;

        while (y-- >= 0 && matchStartColor(pixelPos)) {
            pixelPos -= canvasWidth * 4;
            // context.putImageData(test, x, y);
        }
        // context.putImageData(test, x, y);

        pixelPos += canvasWidth * 4;
        ++y;
        let reachLeft = false;
        let reachRight = false;


        while (y++ < canvasHeight - 1 && matchStartColor(pixelPos)) {
            colorPixel(pixelPos);

            if (x > 0) {
                if (matchStartColor(pixelPos - 4)) {
                    if (!reachLeft) {
                        pixelStack.push([x - 1, y]);
                        reachLeft = true;
                    }
                }
                else if (reachLeft) {
                    reachLeft = false;
                }
            }

            if (x < canvasWidth - 1) {
                if (matchStartColor(pixelPos + 4)) {
                    if (!reachRight) {
                        pixelStack.push([x + 1, y]);
                        reachRight = true;
                    }
                }
                else if (reachRight) {
                    reachRight = false;
                }
            }

            pixelPos += canvasWidth * 4;
        }
    }

    context.putImageData(imageData,0,0);

    function matchStartColor(pixelPos) {
        // var r = imageData.data[pixelPos];
        // var g = imageData.data[pixelPos + 1];
        // var b = imageData.data[pixelPos + 2];

        // return (r == startR && g == startG && b == startB);

        // return (imageData.data[pixelPos] == startR 
        //     &&  imageData.data[pixelPos + 1] == startG 
        //     &&  imageData.data[pixelPos + 2] == startB
        // );

        let compare = compareWithinRange.bind(this, 15);
        return compare(imageData.data[pixelPos], startR)
            && compare(imageData.data[pixelPos + 1] , startG)
            && compare(imageData.data[pixelPos + 2] , startB)
            && compare(imageData.data[pixelPos + 3] , startA)
    }

    function matchStartColorByColor({R, G, B, A}) {
        let compare = compareWithinRange.bind(this, 15);

        if(R === undefined || G === undefined || B === undefined) return false;
        return compare(R, startR)
            && compare(G, startG)
            && compare(B, startB)
            && compare(A, startA)
    }

    function compareWithinRange(range, x,y) {
        return Math.abs(x - y) <= range;
        // return x >= y - range && x <= y + range;
    }

    function colorPixel(pixelPos: number) {
        imageData.data[pixelPos] =     fillColor[0];
        imageData.data[pixelPos + 1] = fillColor[1];
        imageData.data[pixelPos + 2] = fillColor[2];
        imageData.data[pixelPos + 3] = fillColor[3];
    }
}

export {
    scaleImage,
    paintBucket
}

//#region Depricated
// function putImageEdgesOnCanvas(image: HTMLImageElement, context: CanvasRenderingContext2D) {

//     let canvasData = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
//     let imageData = getImageData(image);


//     let iw = image.width;
//     let ih = image.height;
//     let canvasWidth = context.canvas.width;

//     for (let y = 0, pixelPos = 0, imagePos = 0; y < ih; y++) {
//         pixelPos = y * canvasWidth;
//         imagePos = y * iw;
//         for (let x = 0; x < iw; x++) {
//             let R = imageData.data[imagePos];
//             let G = imageData.data[imagePos + 1];
//             let B = imageData.data[imagePos + 2];
//             if (R <= 10 && G <= 10 && B <= 10) {
//                 canvasData.data[pixelPos] = R;
//                 canvasData.data[pixelPos + 1] = G;
//                 canvasData.data[pixelPos + 2] = B;
//             }
//             pixelPos += 4;
//             imagePos += 4;
//         }
//     }

//     return canvasData;
// }

// function getImageData(image: HTMLImageElement) {
//     // creating TempCanvas to get image data
//     let tempCanvas = document.createElement('canvas');
//     tempCanvas.height = image.height;
//     tempCanvas.width = image.width;

//     let CTX = tempCanvas.getContext('2d');
//     CTX.drawImage(image, 0, 0, image.width, image.height);

//     let imageData = CTX.getImageData(0, 0, tempCanvas.width, tempCanvas.height);

//     return imageData;
// }

// function mutateImage(imageData: ImageData) {
//     let arr = imageData.data;
//     let range = 20;
//     for (var i = 0; i < arr.length; i += 4) {
//         // for(let j = i; j < i + 3; j++) {
//         //   arr[j] = arr[j] > 240 ? 255 : 0;
//         // }

//         for (let j = i; j < i + 3; j++) {
//             arr[j] = arr[j] % range > range / 2 ?
//                 arr[j] + (range - arr[j] % range) :
//                 arr[j] - arr[j] % range;
//         }


//         // arr[i] = arr[i] - arr[i] % 20;
//         // arr[i+1] = arr[i+1] - arr[i+1] % 20;
//         // arr[i+2] = arr[i+2] - arr[i+2] % 20;
//     }
// }
//#endregion